import store from "store/store";


export const modificationListSelectors = {
	isFetching: (state = store.getState()) => state.modifications.isFetching,
	isRefresh: (state = store.getState()) => state.modifications.isRefresh,
	error: (state = store.getState()) => state.modifications.error,
	content: (state = store.getState()) => state.modifications.content,
	isModification: (state = store.getState()) => state.modifications.content.latestModificationNumber > 0,
};
